import {
  PdfSearchUtil
} from "./chunk-BJC25M5U.js";
import {
  SectionElement,
  defineElement,
  on,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/shop-catalogs/shop-catalogs.ts
var ShopCatalogs = class extends SectionElement {
  get source() {
    const settingsData = this.getAttribute("data-section-settings");
    if (settingsData) {
      try {
        const settings = JSON.parse(settingsData);
        return settings.source || "";
      } catch (error) {
        console.error("Failed to parse section settings:", error);
      }
    }
    return "";
  }
  handleInput() {
    const hasValue = this.searchInput.value.trim().length > 0;
    if (hasValue) {
      this.searchButton.removeAttribute("disabled");
    } else {
      this.searchButton.setAttribute("disabled", "");
      this.catalogItems.forEach((item) => {
        item.classList.remove("hidden");
      });
      this.noResultsMessage.classList.add("hidden");
    }
  }
  handleKeydown(element, event) {
    if (event.key === "Enter") {
      if (element.value.trim().length > 0) {
        this.performSearch();
      }
    }
  }
  handleClick() {
    if (this.searchInput.value.trim().length > 0) {
      this.performSearch();
    }
  }
  performSearch() {
    return __async(this, null, function* () {
      const searchTerm = this.searchInput.value.trim();
      if (!searchTerm) {
        this.catalogItems.forEach((item) => {
          item.classList.remove("hidden");
        });
        this.noResultsMessage.classList.add("hidden");
        return;
      }
      const currentSource = this.source;
      const isCatalogSource = currentSource === "global_catalog" || currentSource === "select_catalog";
      if (isCatalogSource) {
        yield this.performPdfSearch(searchTerm);
      } else {
        this.performLocalSearch(searchTerm);
      }
    });
  }
  performPdfSearch(searchTerm) {
    return __async(this, null, function* () {
      try {
        const [results] = yield Promise.all([
          PdfSearchUtil.searchPdf(searchTerm)
        ]);
        const pdfTitles = PdfSearchUtil.createPdfTitleSet(results);
        const localMatches = /* @__PURE__ */ new Set();
        this.catalogItems.forEach((item) => {
          var _a;
          const title = ((_a = item.getAttribute("data-catalog-title")) == null ? void 0 : _a.toLowerCase()) || "";
          if (this.matchesSearch(searchTerm.toLowerCase(), title, "", "")) {
            localMatches.add(title);
          }
        });
        const combinedTitles = /* @__PURE__ */ new Set([...pdfTitles, ...localMatches]);
        this.filterItemsByPdfResults(combinedTitles);
      } catch (error) {
        console.error("PDF search failed:", error);
        this.performLocalSearch(searchTerm);
      }
    });
  }
  filterItemsByPdfResults(pdfTitles) {
    let visibleCount = 0;
    this.catalogItems.forEach((item) => {
      var _a;
      const title = ((_a = item.getAttribute("data-catalog-title")) == null ? void 0 : _a.toLowerCase()) || "";
      if (pdfTitles.has(title)) {
        item.classList.remove("hidden");
        visibleCount++;
      } else {
        item.classList.add("hidden");
      }
    });
    if (visibleCount < 1) {
      this.noResultsMessage.classList.remove("hidden");
    } else {
      this.noResultsMessage.classList.add("hidden");
    }
  }
  performLocalSearch(searchTerm) {
    const searchTermLower = searchTerm.toLowerCase();
    let visibleCount = 0;
    this.catalogItems.forEach((item) => {
      var _a, _b, _c;
      const title = ((_a = item.getAttribute("data-catalog-title")) == null ? void 0 : _a.toLowerCase()) || "";
      const url = ((_b = item.getAttribute("data-catalog-url")) == null ? void 0 : _b.toLowerCase()) || "";
      const description = ((_c = item.getAttribute("data-catalog-description")) == null ? void 0 : _c.toLowerCase()) || "";
      if (this.matchesSearch(searchTermLower, title, url, description)) {
        item.classList.remove("hidden");
        visibleCount++;
      } else {
        item.classList.add("hidden");
      }
    });
    if (visibleCount < 1) {
      this.noResultsMessage.classList.remove("hidden");
    } else {
      this.noResultsMessage.classList.add("hidden");
    }
  }
  matchesSearch(searchTerm, title, url, description) {
    const normalizeText = (text) => {
      return text.toLowerCase().replace(/[äöüß]/g, (char) => {
        const replacements = { "\xE4": "ae", "\xF6": "oe", "\xFC": "ue", "\xDF": "ss" };
        return replacements[char] || char;
      }).replace(/[^\w\s]/g, " ").replace(/\s+/g, " ").trim();
    };
    const normalizedSearchTerm = normalizeText(searchTerm);
    const normalizedTitle = normalizeText(title);
    const normalizedUrl = normalizeText(url);
    const normalizedDescription = normalizeText(description);
    const searchWords = normalizedSearchTerm.split(" ").filter((word) => word.length > 0);
    return searchWords.every((word) => {
      return normalizedTitle.includes(word) || normalizedUrl.includes(word) || normalizedDescription.includes(word);
    });
  }
};
__decorateClass([
  query("[data-catalog-search-input]")
], ShopCatalogs.prototype, "searchInput", 2);
__decorateClass([
  query("[data-catalog-search-button]")
], ShopCatalogs.prototype, "searchButton", 2);
__decorateClass([
  queryAll("[data-catalog-item]")
], ShopCatalogs.prototype, "catalogItems", 2);
__decorateClass([
  query("[data-catalog-no-results]")
], ShopCatalogs.prototype, "noResultsMessage", 2);
__decorateClass([
  on("input", "[data-catalog-search-input]")
], ShopCatalogs.prototype, "handleInput", 1);
__decorateClass([
  on("keydown", "[data-catalog-search-input]")
], ShopCatalogs.prototype, "handleKeydown", 1);
__decorateClass([
  onClick("[data-catalog-search-button]")
], ShopCatalogs.prototype, "handleClick", 1);
ShopCatalogs = __decorateClass([
  defineElement("shop-catalogs")
], ShopCatalogs);
export {
  ShopCatalogs
};
